import React, { useContext } from 'react';
import pt from 'prop-types';
import Text from '../../../../ui/text';
import Container from '../../../../../modules/container';
import AwardBadge from '../../../../ui/awardBadge';
import * as styles from './styles.module.scss';
import { MicrocopyContext } from '../../../../../context/microcopy.context';
import { getCopy } from '../../../../../helpers/copy';
import { combine } from '../../../../../helpers/styles';
import {
  COMPANY_RANKING_TYPES,
  DYNAMIC_PAGE_TYPES,
  IF_RANKING_PROFILE_TYPES,
} from '../../../../../utils/constants';
import Link from '../../../../ui/link';

const Ranking = ({ rankings, type, profileId }) => {
  const microcopy = useContext(MicrocopyContext);
  const yearMin = rankings.sort(
    (a, b) => parseInt(a.labelAwardMinYear) - parseInt(b.labelAwardMinYear)
  )[0].labelAwardMinYear;
  const yearMax = rankings.sort(
    (a, b) => parseInt(b.labelAwardMaxYear) - parseInt(a.labelAwardMaxYear)
  )[0].labelAwardMaxYear;

  const getProfileTypeId = (type) => {
    const key = Object.entries(COMPANY_RANKING_TYPES).find(
      ([_, value]) => value === type
    )[0];

    return IF_RANKING_PROFILE_TYPES[key];
  };

  const getLinkQueryParams = (item) => {
    let queryParams = `profileTypes=${getProfileTypeId(
      type
    )}&profileId=${profileId}`;

    if (item.continent) {
      if (item.country) {
        queryParams += `&countries=${item.country}`;
      } else {
        queryParams += `&continents=${item.continent}`;
      }
    }

    if (item.keyword) {
      queryParams += `&keywords=${item.keyword}`;
    }

    if (item.rankingPage > 0) {
      queryParams += `&page=${item.rankingPage + 1}`;
    }

    return queryParams;
  };

  return (
    <Container fullWidth className={combine(styles.ranking)}>
      <Container>
        <div className={styles.header}>
          <AwardBadge name="ifTopLabel" className={styles.icon} />
          <div className={styles.text}>
            <Text as="h2" type="h1" className={styles.title}>
              {getCopy('label.ifRanking', microcopy)}
            </Text>
            <Text as="h3" className={styles.subtitle}>
              {`${yearMin} - ${yearMax} — ${getCopy(
                `label.ranking.${type}`,
                microcopy
              )}`}
            </Text>
          </div>
        </div>
        <div>
          {rankings.map((item, index) => (
            <Link
              link={{
                linkToDynamicPage: DYNAMIC_PAGE_TYPES.RANKING_FILTER,
                queryParameter: getLinkQueryParams(item),
                anchor: 'resultList',
              }}
              className={styles.rankingItem}
            >
              <div className={styles.rank}>
                <Text
                  as="span"
                  type="h2"
                  variant="semibold"
                  className={styles.position}
                >
                  {item.rank}
                </Text>
                <Text as="span" type="p3" className={styles.contenders}>
                  {`${getCopy('label.ranking.of', microcopy)} ${
                    item.categoryFilterTotal
                  }`}
                </Text>
              </div>
              <Text as="span" className={styles.country}>
                {item.countryLabel ||
                  item.continentLabel ||
                  `${getCopy('label.ranking.worldwide', microcopy)}`}
              </Text>
              <Text as="span" className={styles.category}>
                {item.keywordLabel ||
                  `${getCopy('label.ranking.allIndustries', microcopy)}`}
              </Text>
            </Link>
          ))}
        </div>
      </Container>
    </Container>
  );
};

Ranking.propTypes = {
  rankings: pt.array,
};

Ranking.defaultProps = {
  ranking: [],
};

export default Ranking;
